// extracted by mini-css-extract-plugin
export var chevron = "_3d-2";
export var chevronCollapsed = "_3d-3";
export var collapsibleHeader = "_3d-1";
export var container = "_3d-0";